import React from 'react';
import CardWithTitle from 'components/CardWithTitle';

import BuyerPaymentSection from './BuyerPaymentSection';
import SellerPaymentSection from './SellerPaymentSection';

const PaymentSection = ({
  values,
  handleShowProof,
  setFieldValue,
  grandTotal,
  refetchOrderData,
  onOrderUpdated,
}) => {
  return (
    <CardWithTitle title="Payment Details">
      <BuyerPaymentSection
        values={values}
        handleShowProof={handleShowProof}
        setFieldValue={setFieldValue}
        grandTotal={grandTotal}
        refetchOrderData={refetchOrderData}
        onOrderUpdated={onOrderUpdated}
      />
      <SellerPaymentSection
        values={values}
        handleShowProof={handleShowProof}
        setFieldValue={setFieldValue}
        grandTotal={grandTotal}
        refetchOrderData={refetchOrderData}
        onOrderUpdated={onOrderUpdated}
      />
    </CardWithTitle>
  );
};

export default PaymentSection;
